import type { Database } from "@/integrations/supabase/types";

export type PublicationStatus = Database["public"]["Enums"]["agora_publication_status"];

/** Libellés éditoriaux, sans jargon technique ni abréviation. */
export const PUBLICATION_STATUS_LABELS: Record<PublicationStatus, string> = {
  draft: "Brouillon",
  pending_review: "En attente de revue juridique",
  published: "Publiée",
  rejected: "Renvoyée pour correction",
  archived: "Archivée",
};

export const PUBLICATION_STATUS_TONES: Record<PublicationStatus, string> = {
  draft: "bg-muted text-muted-foreground",
  pending_review: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  published: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  rejected: "bg-destructive/15 text-destructive",
  archived: "bg-muted text-muted-foreground",
};

export function isEditable(status: PublicationStatus): boolean {
  return status === "draft" || status === "rejected" || status === "published";
}

export type VerificationStatus = Database["public"]["Enums"]["agora_verification_status"];

/**
 * Libellé unique du statut de vérification professionnelle : le résumé du
 * tableau de bord et la carte détaillée doivent dire exactement la même chose.
 */
export const VERIFICATION_STATUS_LABELS: Record<VerificationStatus, string> = {
  unverified: "Qualité professionnelle non encore vérifiée",
  pending: "Qualité professionnelle en cours de vérification",
  verified: "Qualité professionnelle vérifiée par la rédaction",
};

export function verificationStatusLabel(status: VerificationStatus | string): string {
  if (status in VERIFICATION_STATUS_LABELS) {
    return VERIFICATION_STATUS_LABELS[status as VerificationStatus];
  }
  // Valeur ajoutée ultérieurement à l'énumération (par exemple un rejet) :
  // on reste explicite plutôt que d'afficher un statut faussement rassurant.
  return "Vérification non validée";
}

/** États vides distincts par filtre du tableau de bord. */
export const EMPTY_LIST_MESSAGES: Record<string, string> = {
  all: "Aucune analyse pour le moment. Commencez par un brouillon ci-dessus.",
  draft: "Aucun brouillon en cours. Créez une nouvelle analyse pour commencer à rédiger.",
  pending_review:
    "Aucune analyse en attente de revue juridique. Soumettez un brouillon terminé pour l'y faire figurer.",
  rejected:
    "Aucune analyse à corriger. Les analyses renvoyées par la revue juridique apparaîtront ici.",
  published:
    "Aucune analyse publiée pour l'instant. Vos analyses validées par la revue juridique s'afficheront ici.",
};

export function emptyListMessage(filter: string): string {
  return EMPTY_LIST_MESSAGES[filter] ?? "Aucune analyse dans cette catégorie.";
}

